import type { ReactElement } from 'react';
import React from 'react';

import Head from 'next/head';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

import { defaultLanguage, namespaces, withTranslation } from '@i18n';

import { useTranslation } from '@framework/hooks';
import { I18N_NEXT_COOKIE } from '@framework/utils/cookies';

import Login from '@accounts/pages/NewLogin/Login';

import type { GetServerSideProps } from 'next';

const LoginPage = (): ReactElement | null => {
    const { t } = useTranslation();

    const documentTitle = t('Log in to Sherpany meeting management software');

    return (
        <>
            <Head>
                <title>{documentTitle}</title>
                <meta
                    name="description"
                    itemProp="description"
                    content="Are you a user of Sherpany software looking to prepare your next leadership meeting? Log in to your Sherpany account here."
                />
                <meta
                    name="keywords"
                    itemProp="keywords"
                    content="Leadership, Sherpany, Time, meeting, director, executive, board member, committee"
                />
            </Head>
            <Login />
        </>
    );
};
export const getServerSideProps: GetServerSideProps = async (context) => ({
    props: {
        ...(await serverSideTranslations(
            context?.req?.cookies?.[I18N_NEXT_COOKIE] ?? defaultLanguage,
            namespaces,
            null
        ))
    }
});
export default withTranslation('translations')(LoginPage);
